import ReactGA from 'react-ga4';

const reportWebVitals = () => {
    import('web-vitals').then((webVitals) => {
        const sendToGA = ({ name, delta, value, id }) => {
            ReactGA.event({
                category: 'Web Vitals',
                action: name,
                label: id,
                value: Math.round(name === 'CLS' ? delta * 1000 : delta),
                nonInteraction: true,
            });
        };

        // Call the functions that exist in the imported module
        webVitals.onCLS(sendToGA);
        webVitals.onINP(sendToGA); // onINP is used, which has replaced onFID
        webVitals.onFCP(sendToGA);
        webVitals.onLCP(sendToGA);
        webVitals.onTTFB(sendToGA);
    });
};

export default reportWebVitals;